import Metis from "../metis";

const metis = new Metis();

const wp = wp_metis;

class TrainingAssistant {
  async getAllKursKlassimerkmaleByKlassigruppe(
    kursKlassigruppeId,
    kursklassigruppeFilter
  ) {
    // filter example: [{klassigruppeId: 22, klassiIds: [14]}]

    let request = undefined;
    let query = undefined;
    if (kursklassigruppeFilter == null) {
      query = `
        query{
          getAllKursKlassimerkmaleByKlassigruppe(mandantennummer: ${wp.mandantennummer}, kursKlassigruppeId: ${kursKlassigruppeId}){
            id
            klassiname
          }
        }
      `;
      request = metis.metisRequest({
        query: query,
      });
    } else {
      const filteredkursklassigruppeFilter = kursklassigruppeFilter.filter(
        (f) => f != null && f != undefined && f != []
      );
      const filterString = `[${filteredkursklassigruppeFilter.map((f) => {
        if (f.klassigruppeId && f.klassiIds && f.klassiIds.length > 0) {
          return `{klassigruppeId: ${
            f.klassigruppeId
          }, klassiIds: [${f.klassiIds.map((id) => {
            return `${id}`;
          })}]}`;
        }
      })}]`;

      // console.log(filterString);

      query = `
        query{
          getAllKursKlassimerkmaleByKlassigruppe(mandantennummer: ${wp.mandantennummer}, kursKlassigruppeId: ${kursKlassigruppeId}, kursklassigruppeFilter: ${filterString} ){
            id
            klassiname
          }
        }
      `;

      request = metis.metisRequest({
        query: query,
      });
    }

    // console.log(query);

    const response = await request;

    if (response) {
      return response.getAllKursKlassimerkmaleByKlassigruppe;
    }
  }

  async getFilteredKurse(kursklassigruppeFilter) {
    const filteredkursklassigruppeFilter = kursklassigruppeFilter.filter(
      (f) => f != null && f != undefined && f != []
    );
    const filterString = `[${filteredkursklassigruppeFilter.map((f) => {
      if (f.klassigruppeId && f.klassiIds && f.klassiIds.length > 0) {
        return `{klassigruppeId: ${
          f.klassigruppeId
        }, klassiIds: [${f.klassiIds.map((id) => {
          return `${id}`;
        })}]}`;
      }
    })}]`;


    let request = undefined;
    let query = `
      query{
        getFilteredKurse(mandantennummer:${wp.mandantennummer}, page: 1, pagesize: 100, filter: {klassimerkmalFilter: {klassigruppen: ${filterString}}}){
          totalElements
          totalPages
          kurse {
            kursnr
            produkt {
              produktnr
              bezeichnung
            }
            kursbez
            maxtln
            mintln
            planung
            preis
            sachbearb
            stornotag
            stunden
            abBez
            abArt
            preisRabatt
            keinelastschrift
            aktiv
            beliebtheit
            foerderfaehig
            dauer
          }
        }
      }
    `;
    request = metis.metisRequest({
      query: query,
    });

    // console.log(query);

    const response = await request;

    if (response) {
      return response.getFilteredKurse;
    }
  }
}

export default TrainingAssistant;
